import { FC } from 'react'
import { useNavigate } from 'react-router-dom-v5-compat'
import { TextLink } from 'baby-design'
import css from './page-nav.scss'

interface NavItemProps {
  active: boolean
  path: string
}

const NavItem: FC<NavItemProps> = ({ active, children, path }) => {
  const navigate = useNavigate()

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    navigate(path)
  }

  return (
    <li className={css['nav-item']}>
      <TextLink
        href={path}
        innerContentClassName={css['nav-link']}
        isSelected={active}
        onClick={handleClick}
      >
        {children}
      </TextLink>
    </li>
  )
}

export default NavItem
